import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoFaqWithImg, { EcoFaqWithImgItemProps } from 'eco-design/sections/eco-faq-win-img';
import styles from './index.module.scss';
import EfSection from '@elem/ui/ef-section';

const JK: React.FC = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail.PowerBackup');
    const items: EcoFaqWithImgItemProps[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1747900020582/%E7%99%BD%E5%A4%A9-%E5%BA%AD%E9%99%A2%E5%A4%AA%E9%98%B3%E8%83%BD.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1747900021596/Rectangle%2050878.jpg',
            title: t('PowerBackup_item1_title'),
            desc: t('PowerBackup_item1_desc'),
            isVideo: true,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1748250873706/%E5%A4%9C%E6%99%9A%20%E6%B2%B9%E6%9C%BA_1.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1748250902970/Rectangle%2050878.jpg',
            title: t('PowerBackup_item2_title'),
            desc: t('PowerBackup_item2_desc'),
            isVideo: true,
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748317550893/Rectangle%2050879.jpg',
            title: t('PowerBackup_item3_title'),
            desc: t('PowerBackup_item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747900354181/Frame%201612707566.jpg',
            title: t('PowerBackup_item4_title'),
            desc: t('PowerBackup_item4_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747900247795/Frame%201612707567.jpg',
            title: t('PowerBackup_item5_title'),
            desc: t('PowerBackup_item5_desc'),
        },
    ];

    return (
        <div className={`${styles.comp} PowerBackup`} id="PowerBackup">
            <EcoSpace />
            <EfSection label={t('PowerBackup_label')} title={t('PowerBackup_title')} />
            <EcoSpaceSmall />
            <EcoFaqWithImg items={items} />
            <EcoSpace />
        </div>
    );
};

export default JK;
